import { Component } from '@angular/core';

@Component({
  selector: 'app-cards6-examples-39',
  templateUrl: './cards6-examples-39.component.html'
})
export class Cards6Examples39Component {}
